import { ASSET_BASE } from './assetBase';

/**
 * 把后端返回的图片路径拼成可直接访问的 URL。
 * 各页面原来各自手写 `${ASSET_BASE}${path}`，一旦后端返回带域名的绝对地址、
 * 或 ASSET_BASE 末尾多了斜杠就会拼出 `http://host//avataruploads/x.png`，这里统一处理。
 * @param {string} path 后端返回的图片路径（相对或绝对）
 * @returns {string}
 */
export function resolveImageUrl(path) {
    if (!path) return '';
    const value = String(path).trim();
    if (!value) return '';
    // 已经是绝对地址或 dataURL 就直接用
    if (/^(https?:)?\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:')) {
        return value;
    }
    const base = String(ASSET_BASE || '').replace(/\/+$/, '');
    const suffix = value.startsWith('/') ? value : '/' + value;
    return base + suffix;
}
